itsoftApp.createModule("youtubeVideo", ["pageLoad", "popups"], function() {
    var module = this;
    var ytLoaded = false;
    var popupOpened = false;
    

    var init = function () {
        if (ytLoaded) {
            return;
        }

        ytLoaded = true;

        const targetPopup = document.querySelector("#yt-video-popup");
        const popupVideoContainer = targetPopup && targetPopup.querySelector(".video-popup__container");
        var playButtons = document.querySelectorAll('.js-video-yt');
        var initialized = false;

        var getSubstringAfterLastSlash = function (url) {
            const lastSlashIndex = url.lastIndexOf('/');
            if (lastSlashIndex === -1) {
              return url;
            }
            return url.substring(lastSlashIndex + 1);
        }

        window.onYouTubeIframeAPIReady = function () {
            playButtons.forEach(function(targetButton, index) {
                const videoId = targetButton.getAttribute("data-id") || getSubstringAfterLastSlash(targetButton.getAttribute("data-video-source"));
                iframeIds.push(videoId);
                const currentVideo = document.createElement('div');
                currentVideo.classList.add('video-popup__item');
                currentVideo.id = videoId;
                popupVideoContainer.appendChild(currentVideo);
            });
        
            iframeIds.forEach(function(iframeId) {
                var player = new YT.Player(iframeId,{
                    videoId: iframeId,
                    events: {
                        onReady: onPlayerReady
                    }
                });
            });
        }

        var iframeIds = [];
        var iframeObjects = [];

        const loadYouTubeAPI = function () {
            const tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            document.body.appendChild(tag);
        }

        const pauseAfterClosePopup = function () {
            if (initialized) {
                iframeObjects.forEach(function(scopediframeObject) {
                    scopediframeObject.pauseVideo();
                    var scopediframeElement = scopediframeObject.g;
                    scopediframeElement.classList.remove('isPlaying');
                });
            }

            popupOpened = false;
        }

        const playAfterOpenPopup = function () {
            popupOpened = true;
        }

        const onPlayerReady = function (event) {
            initialized = true;

            var iframeObject = event.target;
            // var iframeElement = iframeObject.g;
        
            iframeObjects.push(iframeObject);
            
        
            playButtons.forEach(button => {
                button.addEventListener('click', (e)=>{
                    e.preventDefault();
                    const targetButton = e.target.closest('.js-video-yt');
                    const videoId = targetButton.getAttribute("data-id") || getSubstringAfterLastSlash(targetButton.getAttribute("data-video-source"));

                    iframeObjects.forEach(function(scopediframeObject) {
                        scopediframeObject.pauseVideo();
                        var scopediframeElement = scopediframeObject.g;
                        scopediframeElement.classList.remove('isPlaying');
                        if (scopediframeElement.id === videoId) {
                            scopediframeElement.classList.add('isPlaying');
                            scopediframeObject.playVideo();
                        }
                    });
                }
                );
            }
            );

            if (preLoadedVideoId && popupOpened) {
                iframeObjects.forEach(function(scopediframeObject) {
                    scopediframeObject.pauseVideo();
                    var scopediframeElement = scopediframeObject.g;
                    scopediframeElement.classList.remove('isPlaying');
                    if (scopediframeElement.id === preLoadedVideoId) {
                        scopediframeElement.classList.add('isPlaying');
                        scopediframeObject.playVideo();
                    }
                });
            }
        }

        var initYoutube = function () {
            if (!initialized) {
                loadYouTubeAPI();
            }
        }

        let preLoadedVideoId = null;

        if (playButtons.length > 0) {
            targetPopup.addEventListener(window.evNameOpen, playAfterOpenPopup);
            targetPopup.addEventListener(window.evNameClose, pauseAfterClosePopup); // в модуле popups созданы кастомные события для управления попапом

            playButtons.forEach(button => {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    targetPopup.dispatchEvent(openEvent);

                    if (!initialized) {
                        preLoadedVideoId = button.getAttribute("data-id") || getSubstringAfterLastSlash(button.getAttribute("data-video-source"));
                    } else {
                        preLoadedVideoId = null;
                    }
                });
            });
            initYoutube();
        }
    }

    module.callback = init;
});
